/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserInventoryPreferencePartial } from '../../models/user-inventory-preference-partial';
import { UserInventoryPreferenceWithRelations } from '../../models/user-inventory-preference-with-relations';

export interface UpdateById$Params {
  inventoryId: string;
      body?: UserInventoryPreferencePartial
}

export function updateById(http: HttpClient, rootUrl: string, params: UpdateById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInventoryPreferenceWithRelations>> {
  const rb = new RequestBuilder(rootUrl, updateById.PATH, 'patch');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserInventoryPreferenceWithRelations>;
    })
  );
}

updateById.PATH = '/user/inventory-preference/{inventoryId}';
